import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Input, Button, Loading, Modal } from 'components/elements'
import { getAlphaRgb } from 'components/layouts'
import { useSession } from 'context/Session'
import { format } from 'date-fns'
import Linkify from 'linkify-react'
import Link from 'next/link'
import { useSnackbar } from 'notistack'
import * as R from 'ramda'
import { useState } from 'react'
import { BiUpvote, BiDownvote } from 'react-icons/bi'
import { GrFormClose } from 'react-icons/gr'
import { MdOutlineMoreHoriz } from 'react-icons/md'
import { RiChat1Fill } from 'react-icons/ri'
import { useQuery } from 'react-query'
import styled, { css } from 'styled-components'

import {
  // loadQuestions,
  loadComments,
  deleteComment,
  deleteQuestion,
  postVote,
  removeVote,
  publishComment,
  updateComment,
  publishAnswer,
} from '../modules/datasource'

export const Container = styled.div`
  width: 100%;
  max-width: 704px;
  background: ${({ theme }) => theme.colors.lightGrey};
  display: flex;
  flex-direction: column;
  textarea {
    min-width: 100%;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 6px;
  margin-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => getAlphaRgb(theme.colors.grey, 0.5)};
`

export const Title = styled.div`
  ${({ theme }) => theme.font.h3}
  margin-bottom: 24px;
`

export const Sumary = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => getAlphaRgb(theme.colors.grey, 0.5)};
  margin: -8px;
  flex-wrap: wrap;
`

const AnswerBubble = styled(RiChat1Fill)`
  color: ${({ theme }) => theme.colors.accentMint};
  font-size: 30px;
`
const QuestionBubble = styled(AnswerBubble)`
  color: ${({ theme }) => theme.colors.accentLilac};
  transform: scaleX(-1);
`
const CommentBubble = styled(AnswerBubble)`
  color: ${({ theme }) => theme.colors.grey};
  transform: scaleX(-1);
`
const StyledAMQItem = styled.div`
  display: flex;
  align-items: center;
  margin: 8px;
`
const StyledAMQBubble = styled.div`
  position: relative;
  width: fit-content;
  height: 28px;
`
const QuestionBubbleDesc = styled.div`
  position: absolute;
  top: 1px;
  left: calc(50% - 7px);
  ${({ theme }) => theme.font.bold}
`
const AnswerBubbleDesc = styled.div`
  position: absolute;
  top: 1px;
  left: calc(50% - 6px);
  ${({ theme }) => theme.font.bold}
`
const CommentBubbleDesc = styled.div`
  position: absolute;
  top: -9px;
  left: calc(50% - 9px);
  ${({ theme }) => theme.font.bold}
  ${({ theme }) => theme.font.h3}
`
const AMQItemDesc = styled.div`
  margin-left: 4px;
`
// export const AMQFooterQuestionItem = ({ questions }) => {
//   return (
//     <StyledAMQItem>
//       <StyledAMQBubble>
//         <QuestionBubble />
//         <QuestionBubbleDesc>Q</QuestionBubbleDesc>
//       </StyledAMQBubble>
//       <AMQItemDesc>
//         {questions}&nbsp;{`question${questions === 1 ? '' : 's'}`}
//       </AMQItemDesc>
//     </StyledAMQItem>
//   )
// }
export const AMQFooterAnswersItem = ({ answers }) => {
  return (
    <StyledAMQItem>
      <StyledAMQBubble>
        <AnswerBubble />
        <AnswerBubbleDesc>A</AnswerBubbleDesc>
      </StyledAMQBubble>
      <AMQItemDesc>
        {answers}&nbsp;{`answer${answers === 1 ? '' : 's'}`}
      </AMQItemDesc>
    </StyledAMQItem>
  )
}
export const AMQFooterCommentItem = ({ comments }) => {
  return (
    <StyledAMQItem>
      <StyledAMQBubble>
        <CommentBubble />
        <CommentBubbleDesc>...</CommentBubbleDesc>
      </StyledAMQBubble>
      <AMQItemDesc>
        {comments}&nbsp;{`comment${comments === 1 ? '' : 's'}`}
      </AMQItemDesc>
    </StyledAMQItem>
  )
}
const PublishContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .MuiInputBase-root {
    background-color: white;
  }
`
const PublishFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 5px;
`

const linkifyOptions = {
  render: ({ attributes, content }) => (
    <a {...attributes} target="_blank" rel="noreferrer">
      {content}
    </a>
  ),
}

export const PublishOption = ({
  label = 'Answer',
  publishLabel = 'Post',
  anyFetching,
  setAnyFetching,
  onPublish,
  defaultValue = '',
  onCancel,
  autoFocus,
  asTSN,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [isFetching, setIsFetching] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [text, setText] = useState(defaultValue)

  const autoFocusConfig = autoFocus
    ? {
        autoFocus: true,
        onFocus: e =>
          e.currentTarget.setSelectionRange(
            e.currentTarget.value.length,
            e.currentTarget.value.length
          ),
      }
    : {}

  const handleClose = () => {
    setAnchorEl(null)
  }

  const publish = props => {
    const { asTSN } = props || {}
    setAnyFetching(true)
    setIsFetching(true)
    try {
      onPublish({ text, createAsStaff: asTSN }).then(() => {
        setText('')
        setIsFetching(false)
        setAnyFetching(false)
      })
    } catch (e) {
      enqueueSnackbar('Something went wrong', {
        variant: 'error',
      })
      setAnyFetching(false)
      setIsFetching(false)
    }
  }

  const handleClick = event => {
    if (asTSN) {
      setAnchorEl(event.currentTarget)
      return
    }

    publish()
  }

  return (
    <PublishContainer>
      <Input
        label={label}
        multiline
        minRows={3}
        inputProps={{
          maxLength: 3000,
        }}
        disabled={anyFetching || isFetching}
        value={text}
        onChange={e => setText(e?.target?.value)}
        helperText={`${text.length}/3000`}
        {...autoFocusConfig}
      />
      <PublishFooter>
        {onCancel && (
          <Button
            disabled={anyFetching || isFetching || !text}
            type="button"
            variant="text"
            onClick={onCancel}
          >
            Cancel
          </Button>
        )}
        <Button
          disabled={anyFetching || isFetching || !text}
          loading={isFetching}
          type="button"
          variant="text"
          onClick={handleClick}
        >
          {publishLabel}
        </Button>
        {asTSN && (
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem
              onClick={async () => {
                await publish({ asTSN: false })
                handleClose()
              }}
            >
              Post
            </MenuItem>
            <MenuItem
              onClick={async () => {
                await publish({ asTSN: true })
                handleClose()
              }}
            >
              Post as TSN
            </MenuItem>
          </Menu>
        )}
      </PublishFooter>
    </PublishContainer>
  )
}

const StyledList = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledComment = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0 32px;
  & + & {
    border-top: solid 1px ${({ theme }) => theme.colors.grey2};
  }
`
const StyledReply = styled(StyledComment)`
  padding: 0;
`
const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 12px;
`

const AuthorContainer = styled.div`
  display: flex;
  align-items: center;
`
const AuthorContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: ${({ theme }) => theme.colors.grey};
  margin-left: 4px;
  ${({ theme }) => theme.font.label};
`
const AuthorName = styled.div`
  display: flex;
  align-items: center;
`
const AuthorDesc = styled.div`
  color: ${({ theme }) => theme.colors.grey};
`
const StyledAuthorName = styled(Link)`
  text-decoration: underline;
`
const EditedTag = styled.span`
  cursor: pointer;
`

const HistoryList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 18px;
  padding: 0 15px 30px;
`
const HistoryItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 4px;
`
const HistoryItemDate = styled.div`
  ${({ theme }) => theme.font.label};
  color: ${({ theme }) => theme.colors.grey};
`
const HistoryItemContent = styled.div`
  padding: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.grey2};
`
export const HystoryModal = styled(Modal)`
  max-width: 500px !important;
  max-height: 50vh;
`

const Author = ({ profile, createdAt, isAnswering, isComment, history }) => {
  const ref = `/p/${profile.username}`
  const [isModal, setModal] = useState(false)

  return (
    <AuthorContainer key={`author-${profile?.username}`}>
      {isAnswering ? (
        <StyledAMQBubble>
          <AnswerBubble />
          <AnswerBubbleDesc>A</AnswerBubbleDesc>
        </StyledAMQBubble>
      ) : isComment ? (
        <StyledAMQBubble>
          <CommentBubble />
          <CommentBubbleDesc>...</CommentBubbleDesc>
        </StyledAMQBubble>
      ) : (
        <StyledAMQBubble>
          <QuestionBubble />
          <QuestionBubbleDesc>Q</QuestionBubbleDesc>
        </StyledAMQBubble>
      )}
      <AuthorContent>
        <AuthorName>
          {isAnswering ? (
            <>
              Answered by&nbsp;
              <StyledAuthorName href={ref} style={{ width: 'fit-content' }}>
                {`${profile?.username || ''}`}
              </StyledAuthorName>
            </>
          ) : (
            <>
              {isComment ? 'Comment from' : 'Asked by'}&nbsp;
              <StyledAuthorName href={ref} style={{ width: 'fit-content' }}>
                {`${profile?.username || ''}`}
              </StyledAuthorName>
            </>
          )}
        </AuthorName>
        <AuthorDesc>
          {createdAt && format(new Date(createdAt), 'MMM. d, yyyy, h:mm aaaa')}
          <EditedTag onClick={() => setModal(true)}>
            {!R.isEmpty(history || []) && ' (Edited)'}
          </EditedTag>
        </AuthorDesc>
      </AuthorContent>
      <HystoryModal
        isOpen={isModal}
        close={() => setModal(false)}
        closeOnOutside
        title="History"
      >
        <HistoryList>
          {(history || [])?.map(({ createdAt, text }) => {
            return (
              <HistoryItem key={`history-${createdAt}`}>
                <HistoryItemDate>
                  {format(new Date(createdAt), 'MMM. d, yyyy, h:mm aaaa')}
                </HistoryItemDate>
                <HistoryItemContent>{text}</HistoryItemContent>
              </HistoryItem>
            )
          })}
        </HistoryList>
      </HystoryModal>
    </AuthorContainer>
  )
}
const StyledText = styled.div`
  margin-bottom: 16px;
  white-space: pre-wrap;
  a {
    color: ${({ theme }) => theme.colors.primary};
  }
`
const CommentActions = styled.div`
  display: flex;
  align-items: center;
`
const CommentAction = styled.div`
  color: ${({ theme, color }) => theme.colors[color] || theme.colors.primary};
  ${({ theme }) => theme.font.bold};
  cursor: pointer;
  user-select: none;
  width: fit-content;
  & + & {
    margin-left: 10px;
  }
`
const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`
const ExtraContainer = styled.div`
  border-left: solid 4px
    ${({ theme, isAnswering }) =>
      theme.colors[isAnswering ? 'accentMint' : 'grey']};
  padding-left: 16px;
  margin-left: 30px;
  margin-top: 24px;
  ${({ theme }) => theme.media.phone} {
    margin-left: 14px;
  }
`
const CloseIcon = styled(GrFormClose)`
  path {
    stroke: ${({ theme }) => theme.colors.primary};
  }
`
const VoteContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};
  transition: all 0.2s ease-in-out;
  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.colors.primary};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`
const UpvoteIcon = styled(BiUpvote)`
  width: 26px;
  height: 26px;
  max-width: 26px;
  max-height: 26px;
  min-width: 26px;
  min-height: 26px;
`
const DownvoteIcon = styled(BiDownvote)`
  width: 26px;
  height: 26px;
  max-width: 26px;
  max-height: 26px;
  min-width: 26px;
  min-height: 26px;
`
const Upvote = ({
  accessToken,
  id,
  setCrrVotes,
  myVote,
  setMyVote,
  isCompleted,
  questionId,
}) => {
  const crrActive = myVote === 'Upvote'
  const handleVote = async () => {
    if (crrActive && accessToken) {
      await removeVote({ accessToken, id, questionId })
      setCrrVotes(R.subtract(R.__, 1))
      setMyVote(null)
      return
    }
    await postVote({ accessToken, id, vote: 'Upvote', questionId })
    setCrrVotes(R.add(myVote === 'Downvote' ? 2 : 1))
    setMyVote('Upvote')
  }
  return (
    <VoteContainer
      onClick={handleVote}
      active={crrActive}
      disabled={!accessToken || isCompleted}
    >
      <UpvoteIcon />
    </VoteContainer>
  )
}
const Downvote = ({
  accessToken,
  id,
  setCrrVotes,
  myVote,
  setMyVote,
  isCompleted,
  questionId,
}) => {
  const crrActive = myVote === 'Downvote'
  const handleVote = async () => {
    if (crrActive && accessToken) {
      await removeVote({ accessToken, id, questionId })
      setCrrVotes(R.add(1))
      setMyVote(null)
      return
    }
    await postVote({ accessToken, id, vote: 'Downvote', questionId })
    setCrrVotes(R.subtract(R.__, myVote === 'Upvote' ? 2 : 1))
    setMyVote('Downvote')
  }
  return (
    <VoteContainer
      onClick={handleVote}
      active={crrActive}
      disabled={!accessToken || isCompleted}
    >
      <DownvoteIcon />
    </VoteContainer>
  )
}
const VotesContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 14px;
`
const ShowCommentsDesc = styled.div`
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`
const ShowComments = ({ onClick, count, disabled }) => {
  return (
    <CommentActions>
      <StyledAMQBubble>
        <CommentBubble />
        <CommentBubbleDesc>...</CommentBubbleDesc>
      </StyledAMQBubble>
      &nbsp;
      <ShowCommentsDesc
        disabled={disabled}
        onClick={() => {
          if (!disabled) {
            onClick()
          }
        }}
      >
        {count}&nbsp;{`comment${count === 1 ? '' : 's'}`}
      </ShowCommentsDesc>
    </CommentActions>
  )
}
const StyledOptions = styled.div`
  cursor: pointer;
  width: 38px;
  height: 38px;
  min-width: 38px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const Question = ({
  username,
  articleSlug,
  text,
  comments,
  votes,
  profile,
  createdAt,
  id,
  anyFetching,
  setAnyFetching,
  setListState: setQuestionsListState,
  setQuestionsCount,
  setAnswersCount,
  setCommentCount,
  // isMyAMQ,
  isStaff,
  isCompleted,
  // answers,
  answer,
  voted,
  accessToken,
  questionId,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [, setDeleteId] = useState(null)
  const [showComments, setShowComments] = useState(false)
  const [showCommentField, setShowCommentField] = useState(false)
  // const [showReply, setShowReply] = useState(false)
  const { user } = useSession()
  const [commentsListState, setCommentsListState] = useState({})
  const [crrPage, setCrrPage] = useState(1)
  const [crrVotes, setCrrVotes] = useState(votes || 0)
  const [crrComments, setCrrComments] = useState(comments || 0)
  const [myVote, setMyVote] = useState(voted)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [optionsConfig, setOptionsConfig] = useState([])
  const [editId, setEditId] = useState(null)
  const [deleteConfig, setDeleteConfig] = useState({})

  const handleOptionsClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleOptionsClose = () => {
    setAnchorEl(null)
  }

  const [crrAnswer, setCrrAnswer] = useState(answer)

  const handleClose = () => !isDeleting && setShowDelete(false)

  const { isFetching } = useQuery(
    [
      'amq-comments',
      { accessToken, username, articleSlug, showComments, id, crrPage },
    ],
    () =>
      showComments
        ? loadComments({
            accessToken,
            id,
            page: crrPage,
          })
        : { list: [], total: 0 },
    {
      fetchPolicy: 'no-cache',
      onSuccess: data =>
        setCommentsListState(({ list = [] }) => ({
          ...data,
          list: R.uniq(R.concat(list || [], data?.list || [])),
        })),
    }
  )

  const config = {
    username,
    articleSlug,
    anyFetching,
    setAnyFetching,
    setListState: setCommentsListState,
    setQuestionsCount,
    setAnswersCount,
    setCommentCount,
  }
  const { list = [], total } = commentsListState

  const onDeleteComment = async id => {
    if (!isDeleting) {
      setIsDeleting(true)
      try {
        await deleteComment({ accessToken, id })
        if (crrComments === 1) {
          setShowComments(false)
        }
        setCommentsListState(state => ({
          total: state?.total - 1,
          list: R.reject(R.propEq(id, 'id'), state?.list),
        }))
        setCommentCount(c => c - 1)
        setCrrComments(c => c - 1)
        setIsDeleting(false)
        setDeleteId(null)
        handleClose()
      } catch (error) {
        setIsDeleting(false)
        setDeleteId(null)
        handleClose()
      }
    }
  }

  const onDeleteAnswer = async id => {
    if (!isDeleting) {
      setIsDeleting(true)
      try {
        await deleteComment({ accessToken, id })
        setCrrAnswer(null)
        setAnswersCount(c => c - 1)
        setIsDeleting(false)
        setDeleteId(null)
        handleClose()
      } catch (error) {
        setIsDeleting(false)
        setDeleteId(null)
        handleClose()
      }
    }
  }

  const onDeleteQuestion = async id => {
    if (!isDeleting) {
      setIsDeleting(true)
      try {
        await deleteQuestion({ accessToken, id, questionId })
        setQuestionsListState(state => ({
          total: state?.total - 1,
          list: R.reject(R.propEq(id, 'id'), state?.list),
        }))
        setAnswersCount(c => c - 1)
        setIsDeleting(false)
        setDeleteId(null)
        handleClose()
      } catch (error) {
        setIsDeleting(false)
        setDeleteId(null)
        handleClose()
      }
    }
  }

  const voteConfig = {
    accessToken,
    id,
    setCrrVotes,
    myVote,
    setMyVote,
    isCompleted,
    questionId,
  }

  const postComment = ({ text }) => {
    setAnyFetching(true)
    return publishComment({ accessToken, id, text }).then(({ data }) => {
      setAnyFetching(false)
      setCommentsListState(({ list = [], ...crrState }) => ({
        ...crrState,
        list: R.concat([data], list),
      }))
      setCommentCount(c => c + 1)
      setCrrComments(c => c + 1)
    })
  }

  const editComment = ({ text }) => {
    setAnyFetching(true)
    return updateComment({ accessToken, id: editId, text }).then(({ data }) => {
      setAnyFetching(false)
      setCommentsListState(({ list = [], ...crrState }) => {
        const index = R.findIndex(R.propEq(editId, 'id'), list)

        return {
          ...crrState,
          list: R.update(index, data, list),
        }
      })
      setEditId(null)
    })
  }

  const postAnswer = ({ text }) => {
    setAnyFetching(true)
    return publishAnswer({ accessToken, id, text }).then(({ data }) => {
      setAnyFetching(false)
      setCrrAnswer(data)
      setEditId(null)
      setAnswersCount(c => c + 1)
    })
  }

  return (
    <StyledComment>
      <CommentHeader>
        <Author profile={profile} createdAt={createdAt} isAnswering />
        {(profile?.username === user?.profile?.username || isStaff) &&
          !isCompleted && (
            <>
              <StyledOptions
                onClick={e => {
                  handleOptionsClick(e)
                  setOptionsConfig([
                    {
                      label: 'Delete',
                      onClick: () => {
                        setDeleteId(id)
                        setDeleteConfig({
                          title: 'Delete question',
                          message:
                            'Are you sure you want to delete this question?',
                          onConfirm: () => onDeleteQuestion(id),
                        })
                        setShowDelete(true)
                        handleOptionsClose()
                      },
                    },
                  ])
                }}
              >
                <MdOutlineMoreHoriz key="options-icon" />
              </StyledOptions>
            </>
          )}
      </CommentHeader>
      <StyledText>
        <Linkify options={linkifyOptions}>{text}</Linkify>
      </StyledText>
      <CommentActions>
        <VotesContainer>
          <Upvote {...voteConfig} />
          &nbsp;
          {crrVotes || 0}&nbsp;
          <Downvote {...voteConfig} />
        </VotesContainer>
        {accessToken && (
          <CommentAction
            color="black"
            onClick={() => setShowCommentField(s => !s)}
          >
            Add Comment
            {showCommentField && <CloseIcon />}
          </CommentAction>
        )}
      </CommentActions>
      {/* {showReply && (
        <ExtraContainer isAnswering>
          <PublishOption
            label="Answer it"
            publishLabel="Post answer"
            onPublish={postAnswer}
            {...config}
          />
        </ExtraContainer>
      )} */}
      {crrAnswer && // Answer list
        [crrAnswer].map(asnw => {
          if (asnw?.id === editId) {
            return (
              <ExtraContainer>
                <PublishOption
                  label="Edit comment"
                  publishLabel="Save"
                  onPublish={postAnswer}
                  defaultValue={asnw?.text}
                  onCancel={() => setEditId(null)}
                  autoFocus
                  {...config}
                />
              </ExtraContainer>
            )
          }

          return (
            <ExtraContainer
              isAnswering
              key={`${asnw?.profile?.username}-${asnw?.createdAt}`}
            >
              <StyledReply>
                <CommentHeader>
                  <Author
                    profile={asnw?.profile}
                    createdAt={asnw?.createdAt}
                    inReview={asnw?.inReview}
                    history={asnw?.history}
                    isAnswering
                  />
                  {asnw?.profile?.username === user?.profile?.username &&
                    !isCompleted && (
                      <>
                        <StyledOptions
                          onClick={e => {
                            handleOptionsClick(e)
                            setOptionsConfig([
                              // {
                              //   label: 'Edit',
                              //   onClick: () => {
                              //     setEditId(asnw?.id)
                              //     handleOptionsClose()
                              //   },
                              // },
                              {
                                label: 'Delete',
                                onClick: () => {
                                  setDeleteId(crrAnswer?.id)
                                  setDeleteConfig({
                                    title: 'Delete answer',
                                    message:
                                      'Are you sure you want to delete this answer?',
                                    onConfirm: () =>
                                      onDeleteAnswer(crrAnswer?.id),
                                  })
                                  setShowDelete(true)
                                  handleOptionsClose()
                                },
                              },
                            ])
                          }}
                        >
                          <MdOutlineMoreHoriz key="options-icon" />
                        </StyledOptions>
                      </>
                    )}
                </CommentHeader>
                <StyledText>
                  <Linkify options={{ target: '_blank' }}>{asnw?.text}</Linkify>
                </StyledText>
              </StyledReply>
            </ExtraContainer>
          )
        })}
      {accessToken && !isCompleted && showCommentField && (
        <ExtraContainer key={accessToken}>
          <PublishOption
            label="Add comment"
            publishLabel="Post comments"
            onPublish={postComment}
            {...config}
          />
        </ExtraContainer>
      )}
      {(showComments || list?.length > 0) && // Comment list
        R.uniqBy(R.prop('id'), list).map(rply => {
          if (rply?.id === editId) {
            return (
              <ExtraContainer>
                <PublishOption
                  label="Edit comment"
                  publishLabel="Save"
                  onPublish={editComment}
                  defaultValue={rply?.text}
                  onCancel={() => setEditId(null)}
                  autoFocus
                  {...config}
                />
              </ExtraContainer>
            )
          }
          return (
            <ExtraContainer
              key={`${rply?.profile?.username}-${rply?.createdAt}`}
            >
              <StyledReply>
                <CommentHeader>
                  <Author
                    profile={rply?.profile}
                    createdAt={rply?.createdAt}
                    inReview={rply?.inReview}
                    history={rply?.history}
                    isComment
                  />
                  {(rply?.profile?.username === user?.profile?.username ||
                    isStaff) &&
                    !isCompleted && (
                      <>
                        <StyledOptions
                          onClick={e => {
                            handleOptionsClick(e)
                            setOptionsConfig([
                              // {
                              //   label: 'Edit',
                              //   onClick: () => {
                              //     setEditId(rply?.id)
                              //     handleOptionsClose()
                              //   },
                              // },
                              {
                                label: 'Delete',
                                onClick: () => {
                                  setDeleteId(rply?.id)
                                  setDeleteConfig({
                                    title: 'Delete comment',
                                    message:
                                      'Are you sure you want to delete this comment?',
                                    onConfirm: () => onDeleteComment(rply?.id),
                                  })
                                  setShowDelete(true)
                                  handleOptionsClose()
                                },
                              },
                            ])
                          }}
                        >
                          <MdOutlineMoreHoriz key="options-icon" />
                        </StyledOptions>
                      </>
                    )}
                </CommentHeader>
                <StyledText>
                  <Linkify options={{ target: '_blank' }}>{rply?.text}</Linkify>
                </StyledText>
              </StyledReply>
            </ExtraContainer>
          )
        })}
      {!showComments && (
        <ExtraContainer>
          <ShowComments
            onClick={() => setShowComments(true)}
            count={crrComments || 0}
            disabled={crrComments === 0}
          />
        </ExtraContainer>
      )}
      {!isFetching && list?.length < total && (
        <ShowMore onClick={() => setCrrPage(p => p + 1)}>
          Show more replies
        </ShowMore>
      )}
      {isFetching && (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      )}
      <Dialog
        open={showDelete}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{deleteConfig?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {deleteConfig?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={isDeleting} variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            loading={isDeleting}
            color="error"
            variant="text"
            onClick={deleteConfig?.onConfirm}
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleOptionsClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {optionsConfig.map(({ label, onClick }) => (
          <MenuItem key={label} onClick={onClick}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </StyledComment>
  )
}

export const ShowMore = styled.div`
  color: ${({ theme }) => theme.colors.black};
  ${({ theme }) => theme.font.bold};
  cursor: pointer;
  user-select: none;
  width: fit-content;
  margin: 0 auto;
  & + & {
    margin-left: 10px;
  }
`

export const QuestionList = ({ list, ...rest }) => {
  return (
    <StyledList>
      {list.map(item => (
        <Question
          {...rest}
          {...item}
          key={`${item?.profile?.username}-${item?.createdAt}`}
        />
      ))}
    </StyledList>
  )
}

const PlaceHolderContainer = styled(Container)`
  align-items: center;
`
const CommentsButton = styled(Button)``

export const CommentPlaceHolder = ({ showComments, count }) => (
  <PlaceHolderContainer>
    <CommentsButton color="black" onClick={showComments}>
      View Comments ({count})
    </CommentsButton>
  </PlaceHolderContainer>
)
